<template>
    <div>
        <div v-if="!showOptionSetting">
            <div class="object-titlebox">
                <div class="object-titlebox-left" v-t="'message.item_stt_extension_setting'"></div>
            </div>
            <div class="object-inner-table">
                <table width=100%>
                    <td style="width:50%" class="object-item" v-t="'message.info_need_purchase_enterprise_plan'"></td>
                </table>
            </div>
        </div>
        <div v-else>
            <!-- ヘッダ -->
            <div class="object-titlebox">
                <div class="title-box-left">
                    <span v-t="'message.title_general_admin_user'" />
                    <div class="title-box-right">
                        <button class="transparent" type="button" v-on:click="addAdminUser()"><img
                                src="@/assets/add_user.svg" alt="" /><span class="normal-command-text"
                                v-t="'message.common_action_add'"></span></button>
                    </div>
                </div>
            </div>
            <!-- テーブル -->
            <table width="100%">
                <!-- テーブルヘッダ -->
                <tr class="dict-title">
                    <td class="object-item1" style="width:15%"
                        v-t="'message.item_login_id'"></td>
                    <td class="object-item1" style="width:15%"
                        v-t="'message.item_display_name'"></td>
                    <td class="object-item1" style="width: 50%"
                        v-t="'message.title_privilege'"></td>
                    <td class="object-item3"
                        v-t="'message.common_action_edit'"></td>
                    <td class="object-item3"
                        v-t="'message.common_action_delete'"></td>
                </tr>
                <!-- テーブルボディ -->
                <tr class="dict-record" v-for="adminUser in adminUserInfoList">
                    <!-- ログインID -->
                    <td class="object-item1">
                        {{ adminUser.userName + "@" + appData.loginId.split("@")[1] }}
                    </td>
                    <td class="object-item1">
                        {{ adminUser.displayName }}
                    </td>
                    <!-- 権限 -->
                    <td class="object-item1">
                        <template v-if="getPermissionTags(adminUser).length">
                            <el-tag
                                v-for="(tag, idx) in getPermissionTags(adminUser)"
                                :key="idx"
                                effect="light"
                                size="mini"
                                :class="['perm-tag', `perm-tag--${tag.category}`]"
                            >
                                {{ tag.text }}
                            </el-tag>
                        </template>
                        <span v-else>-</span>
                    </td>
                    <!-- 編集 -->
                    <td class="object-item3">
                        <button class="transparent" type="button" v-on:click="editAdminUser(adminUser)"><img
                                src="@/assets/edit.svg" alt="" /></button>
                    </td>
                    <!-- 削除 -->
                    <td class="object-item3">
                        <button class="transparent" type="button" v-on:click="deleteAdminUser(adminUser)"><img
                                src="@/assets/icon_delete_user.svg" alt="" /></button>
                    </td>
                </tr>
            </table>
            <addIpRadioGeneralAdminUser v-if="showAdminUserDialog.add" ref="AddIpRadioGeneralAdminUser"
                :appData="appData"
                @save="doAddGeneralAdminUser" @cancel="showAdminUserDialog.add = false"></addIpRadioGeneralAdminUser>
            <addIpRadioGeneralAdminUser v-if="showAdminUserDialog.edit" ref="AddIpRadioGeneralAdminUser"
                :appData="appData" :editMode="true" :initialData="selectedAdminUserDetail"
                @save="doEditGeneralAdminUser" @cancel="showAdminUserDialog.edit = false"></addIpRadioGeneralAdminUser>
            <deleteIpRadioGeneralAdminUser v-if="showAdminUserDialog.delete" ref="DeleteIpRadioGeneralAdminUser" :confirmInfo="confirmInfo"
                @delete="doDeleteAdminUser" @cancel="showAdminUserDialog.delete = false"></deleteIpRadioGeneralAdminUser>
        </div>
    </div>
</template>

<script>
import server from "@/components/ServerApi.js";
import commonUtil from '@/components/commonutil.js';
import constants from '@/components/constants.js';
import AddIpRadioGeneralAdminUser from "@/components/pc/radio/ipradio/AddIpRadioGeneralAdminUser.vue";
import DeleteIpRadioGeneralAdminUser from "@/components/pc/radio/ipradio/DeleteIpRadioGeneralAdminUser.vue";

export default {
    props: ['appData'],

    components: {
        addIpRadioGeneralAdminUser: AddIpRadioGeneralAdminUser,
        deleteIpRadioGeneralAdminUser: DeleteIpRadioGeneralAdminUser,
    },

    data() {
        return {
            showAdminUserDialog: {
                add: false,
                edit: false,
                delete: false,
            },
            adminUserInfoList: [],
            selectedAdminUser: null,
            selectedAdminUserDetail: null,
            confirmInfo: {
                objectName: null,
                objectTitle: null,
            },
        }
    },

    computed: {
        showOptionSetting: function() {
            return true;
        },
    },

    created: function() {
        if (this.showOptionSetting) {
            this.getGeneralAdminUserList();
        }
    },

    methods: {
        getPermissionTags(adminUser) {
            const tags = [];

            // テナント管理権限（赤）
            const isTenantAdmin = commonUtil.checkUserPrivilege(
                adminUser.rights,
                constants.PRIVILEGE_TENANT_ADMIN
            );
            if (isTenantAdmin) {
                tags.push({
                    category: "tenantadmin",
                    type: "",
                    text: commonUtil.getMessageText(this.$i18n, "item_tenant_management_permissions"),
                });
            }

            // コンソール操作権限（緑）
            const consolePermissions = (adminUser.consolePermission || "")
                .split(",")
                .map(s => s.trim())
                .filter(Boolean);

            if (consolePermissions.includes(constants.RADIO_INTEGRATE_PERMISSIONS_CONSOLE.EDIT_USER_AND_GROUP_DEFINITION)) {
                tags.push({
                    category: "console",
                    type: "",
                    text: commonUtil.getMessageText(this.$i18n, "item_create_user_group"),
                });
            }
            if (consolePermissions.includes(constants.RADIO_INTEGRATE_PERMISSIONS_CONSOLE.EDIT_USER_TALKGROUP_ASSIGNMENT)) {
                tags.push({
                    category: "console",
                    type: "",
                    text: commonUtil.getMessageText(this.$i18n, "item_edit_user_talk_group"),
                });
            }
            if (consolePermissions.includes(constants.RADIO_INTEGRATE_PERMISSIONS_CONSOLE.TRACKING)) {
                tags.push({
                    category: "console",
                    type: "",
                    text: commonUtil.getMessageText(this.$i18n, "item_reference_for_location_tracking"),
                });
            }

            // 無線機管理権限（radiomanage）は現状無線機管理一般ユーザーにはつけれないのてチェック不要

            // 無線機操作権限（青）
            const radioPermissions = (adminUser.radioPermission || "")
                .split(",")
                .map(s => s.trim())
                .filter(Boolean);

            if (radioPermissions.includes(constants.RADIO_INTEGRATE_PERMISSIONS_RADIO.EDIT_RADIO_SETTING_DEFINITION)) {
                tags.push({
                    category: "radio",
                    type: "",
                    text: commonUtil.getMessageText(this.$i18n, "item_management_of_radio_settings"),
                });
            }
            if (radioPermissions.includes(constants.RADIO_INTEGRATE_PERMISSIONS_RADIO.EDIT_RADIO_SETTING_ASSIGNMENT)) {
                tags.push({
                    category: "radio",
                    type: "",
                    text: commonUtil.getMessageText(this.$i18n, "item_assigned_of_radio_settings"),
                });
            }
            if (radioPermissions.includes(constants.RADIO_INTEGRATE_PERMISSIONS_RADIO.EDIT_RADIO_SETTING_WIFI_ITEMS_DEFINITION)) {
                tags.push({
                    category: "radio",
                    type: "",
                    text: commonUtil.getMessageText(this.$i18n, "item_edit_wifi_of_radio_settings"),
                });
            }
            if (radioPermissions.includes(constants.RADIO_INTEGRATE_PERMISSIONS_RADIO.EDIT_RADIO_USER_DISPLAY_ITEMS_DEFINITION)) {
                tags.push({
                    category: "radio",
                    type: "",
                    text: commonUtil.getMessageText(this.$i18n, "item_edit_radio_display_name_permission"),
                });
            }

            return tags;
        },

        doAddGeneralAdminUser: function(input) {
            let self = this;
            server.post(
                '/createipradiogeneraladminuser',
                {
                    name: input.userName,
                    displayName: input.displayName,
                    password: input.password,
                    permissions: input.permissions
                }
            ).then((res) => {
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_created_user"));
                        self.getGeneralAdminUserList();
                        self.showAdminUserDialog.add = false;
                        break;
                    case constants.STATUS_ERROR_DENIED:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_create_user_denied"));
                        self.showAdminUserDialog.add = false;
                        break;
                    case constants.STATUS_ERROR_EXCEEDS_MAX_COUNT:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_radio_integrate_general_admin_exceeds_max_count"));
                        self.showAdminUserDialog.add = false;
                        break;
                    case constants.STATUS_ERROR_ALREADY_EXISTED:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_cannot_create_user_duplicate"));
                        break;
                    case constants.STATUS_ERROR_PERMISSION_DENIED:
                        commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_permission_denied_general_admin_operator_lack_rights_permissions"));
                        break;
                    case constants.STATUS_ERROR_GENERAL_ADMIN_NO_RIGHTS_PERMISSION:
                        commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_permission_denied_general_admin_no_rights_permissions"));
                        break;
                    case constants.STATUS_ERROR_GENERAL_ADMIN_TRACKING_PERMISSION_WITH_OTHER:
                        commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_permission_denied_general_admin_tracking_permission_with_others"));
                        break;
                    case constants.STATUS_ERROR_GENERAL_ADMIN_RADIO_SETTING_ALL_PERMISSION_WITH_OTHERS:
                        commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_permission_denied_general_admin_radio_setting_all_permission_with_others"));
                        break;
                    default:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","addUser").replace("{code}",res.data.status));
                        self.showAdminUserDialog.add = false;
                        break;
                }
            })
            .catch( function ( error ) {
                self.showAdminUserDialog.add = false;
                commonUtil.putExceptionErrorMessage(self, "addUser", error);
            });
        },

        doEditGeneralAdminUser: function(input) {
            let self = this;
            server.post(
                '/modifyipradiogeneraladminuser',
                {
                    id: input.id,
                    newDisplayName: input.displayName,
                    newPassword: input.password,
                    newPermissions: input.permissions
                }
            ).then((res) => {
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_modified_user"));
                        self.getGeneralAdminUserList();
                        self.showAdminUserDialog.edit = false;
                        break;
                    case constants.STATUS_ERROR_DENIED:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_create_user_denied"));
                        self.showAdminUserDialog.edit = false;
                        break;
                    case constants.STATUS_ERROR_PERMISSION_DENIED:
                        commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_permission_denied_general_admin_operator_lack_rights_permissions"));
                        break;
                    case constants.STATUS_ERROR_GENERAL_ADMIN_NO_RIGHTS_PERMISSION:
                        commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_permission_denied_general_admin_no_rights_permissions"));
                        break;
                    case constants.STATUS_ERROR_GENERAL_ADMIN_TRACKING_PERMISSION_WITH_OTHER:
                        commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_permission_denied_general_admin_tracking_permission_with_others"));
                        break;
                    default:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","modifyUser").replace("{code}",res.data.status));
                        self.showAdminUserDialog.edit = false;
                        break;
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "modifyUser", error);
                self.showAdminUserDialog.edit = false;
            });
        },


        getGeneralAdminUserList: function () {
            let self = this;
            server.post('/getipradiogeneraladminuserlist', {})
                .then((res) => {
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            self.adminUserInfoList = res.data.userList;
                            break;
                        case constants.STATUS_ERROR_PERMISSION_DENIED:
                            commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_permission_denied_general_admin_operator_lack_rights_permissions"));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getGeneralAdminUserList").replace("{code}",res.data.status));
                            break;
                    }
                })
                .catch(function(error) {
                    commonUtil.putExceptionErrorMessage(self, "getGeneralAdminUserList", error);
                });
        },
        addAdminUser() {
            this.showDialogAfterWritableCheck("add");
        },
        editAdminUser(adminUser) {
            let self = this;
            server.post('/getuserinfoandradiointegratepermissions', { userId: adminUser.userId })
                .then((res) => {
                    if (res.data.status === constants.STATUS_SUCCESS) {
                        self.selectedAdminUserDetail = {
                            id: res.data.userInfo.userId,
                            userName: res.data.userInfo.userName,
                            displayName: res.data.userInfo.displayName,
                            permissions: res.data.permissions
                        };
                        self.showDialogAfterWritableCheck("edit");
                    } else {
                        commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_server_api").replace("{functionName}", "editAdminUser").replace("{code}", res.data.status));
                    }
                })
                .catch((error) => {
                    commonUtil.putExceptionErrorMessage(self, "editAdminUser", error);
                });
        },
        deleteAdminUser(adminUser) {
            this.selectedAdminUser = adminUser;
            this.confirmInfo.objectTitle = commonUtil.getMessageText(this.$i18n, "title_general_admin_user");
            this.confirmInfo.objectName = this.selectedAdminUser.userName;
            this.showDialogAfterWritableCheck("delete");
        },
        doDeleteAdminUser() {
            let self = this;
            server.post('/deleteipradiogeneraladminuser', { userId: this.selectedAdminUser.userId })
                .then((res) => {
                    switch (res.data.status) {
                        case constants.STATUS_SUCCESS:
                            commonUtil.notifyMessage(self, "Success", commonUtil.getMessageText(self.$i18n, "info_deleted_user"));
                            self.getGeneralAdminUserList();
                            break;
                        case constants.STATUS_ERROR_PERMISSION_DENIED:
                            commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_permission_denied_general_admin_operator_lack_rights_permissions"));
                            break;
                        case constants.STATUS_ERROR_GENERAL_ADMIN_ROOT_NODE_PERMISSION_REMAINING:
                            commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_permission_denied_general_admin_root_node_permission_remaining"));
                            break;
                        default:
                            commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_server_api").replace("{functionName}", "deleteAdminUser").replace("{code}", res.data.status));
                            break;
                    }
                    self.showAdminUserDialog.delete = false;
                })
                .catch((error) => {
                    commonUtil.putExceptionErrorMessage(self, "deleteAdminUser", error);
                    self.showAdminUserDialog.delete = false;
                });
        },
        showDialogAfterWritableCheck(command) {
            this.showDialogAfterWritableCheckForTenantAdmin(command);
        },
        async showDialogAfterWritableCheckForTenantAdmin(command) {
            this.showAdminUserDialog[command] = true;
        },
        loadingScreenWith(text) {
            return this.$loading({
                    lock: true ,
                    text: text,
                    spinner: 'el-icon-loading' ,
                    background: 'rgba(0, 0, 0, 0)'
            });
        },
    }
}


</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.icon-help {
    height: 14px;
}
.title-box-right {
    position: relative;
    text-align: right;
    vertical-align: middle;
    font-size: 12px;
    float: right;
}
.title-box-left {
    padding: 10px 10px 10px 20px;
    color: #848991;
    font-size: 12px;
    vertical-align: middle;
}
.object-item1 {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 28px;
    font-size: 12px;
}
.object-item2 {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-right: 28px;
    font-size: 12px;
    width: 10%;
    text-align: center;
}
.object-item3 {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-right: 28px;
    font-size: 12px;
    width: 6%;
    text-align: right;
}
.dict-title {
    background-color: #f6f6f6;
    color: #848991;
}
.dict-record {
    background-color:transparent;
    border-bottom: solid 1px #eee;
}
button.transparent img {
    display: inline;
    vertical-align: middle;
    height: 18px;
}
.perm-tag {
    margin-right: 6px;
    margin-bottom: 4px;
}

/* el-tagは子コンポーネントなので scoped を貫通させる */
::v-deep .perm-tag--tenantadmin {
    background-color: #fff5f5;   /* 少しだけ白寄りに */
    border-color: #f2c2c2;
    color: #d86565;              /* わずかにトーンダウン */
}

::v-deep .perm-tag--console {
    background-color: #f3f9f1;
    border-color: #c6e0c0;
    color: #3fa15b;
}

::v-deep .perm-tag--radio {
    background-color: #f1f7ff;
    border-color: #b4d4f8;
    color: #4a76c5;
}

</style>
